export const lightTheme = {
    body: '#cccccc',
    text: '#363537',
    toggleBorder: '#FFF',
    background: '#363537',
    
}
export const darkTheme = {
    filtergrey: 'grayscale(100%)',
    body: 'rgb(26, 26, 26)',
    text: '#FFF',
    toggleBorder: '#6B8096',
    background: '#999',
    container: '#262626',
    CardSection: '#262626',
    CardFooter: '#262626',
    CardHeader: '#262626',
    Header_bts : '#FFF',
    cardcontactdesc: 'linear-gradient(69deg, rgb(35, 35, 35), rgb(40, 40, 40))',
    cardcontactinfo:' linear-gradient(108deg, #383838, #2f2f2f)',
    cardcontactsocial:'linear-gradient(108deg, rgb(92, 92, 92), rgb(59, 59, 59))',
    btn_social1: '#1a1a1a',
    btn_social2: '#1a1a1a',
    btn_social3: '#1a1a1a',
    textsocial: '#FFF',
}

